module.exports = __webpack_public_path__ + "img/gynecology1.90db9894.jpg";